import { render, staticRenderFns } from "./ModalCancelarRegistro.vue?vue&type=template&id=bdd1e998"
import script from "./ModalCancelarRegistro.vue?vue&type=script&lang=js"
export * from "./ModalCancelarRegistro.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelarRegistro.vue?vue&type=style&index=0&id=bdd1e998&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports